export const POLICIES_LIST = {
  SIGN_TEXT: 'He leído y acepto esta política',
  TITLE: 'Políticas',
  SIGN_BUTTON: 'Firmar',
  SIGNED_TEXT: (date: Date | null) => {
    const dateString = date ? `on ${date.toLocaleDateString()}` : ''
    return `Ya has firmado las políticas ${dateString}`
  },
  SIGN_ALL_TEXT: 'He leído y acepto todas las políticas',
}
